import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallActionsPanel } from '@gem/call/CallView/Shared/CallActionsPanel/CallActionsPanel';
import { CallState } from '@gem/call/CallView/Shared/CallState/CallState';
import { FullScreenButton } from '@gem/call/CallView/Shared/FullScreenButton/FullScreenButton';
import { RecordingPlaceholder } from '@gem/call/CallView/Shared/RecordingPlaceholder/RecordingPlaceholder';
import { ShowMembersButton } from '@gem/call/CallView/Shared/ShowMembersButton/ShowMembersButton';
import { ShowMoreButton } from '@gem/call/CallView/Shared/ShowMoreButton/ShowMoreButton';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';
import { EntireScreenButton } from '@gem/call/components/EntireScreenButton/EntireScreenButton';

import { useFullScreenCallViewPanelPresenter } from './FullScreenCallViewPanel.presenter';
import styles from './FullScreenCallViewPanel.styles.m.css';

interface IPanelProps {
  hasTitle?: boolean;
}

export const FullScreenCallViewPanel: FC<IPanelProps> = observer(({ hasTitle }) => {
  const presenter = useFullScreenCallViewPanelPresenter();

  return (
    <div className={styles.container}>
      {hasTitle && (
        <div className={styles.info}>
          <div
            data-test="callview-info-panel-call-title-text"
            className={styles.title}
          >
            {presenter.callTitle}
          </div>
          <div className={styles.callState}>
            <CallState
              call={presenter.ongoingCall}
              className={styles.callStateTime}
            />
          </div>
        </div>
      )}
      <div className={styles.actionsPanel}>
        <CallActionsPanel className={styles.callActionsPanel} />
      </div>
      <div className={styles.additionalActions}>
        {presenter.ongoingCall?.uiFeatures.participantsControlType !==
          ParticipantsControlType.Disabled && (
          <ShowMembersButton className={styles.additionalActionsGap} />
        )}
        {presenter.isRecording && <RecordingPlaceholder className={styles.additionalActionsGap} />}
        {!presenter.isUnauthorizedCall && (
          <>
            <FullScreenButton className={styles.additionalActionsGap} />
            <EntireScreenButton className={styles.additionalActionsGap} />
          </>
        )}
        <ShowMoreButton className={styles.additionalActionsGap} />
      </div>
    </div>
  );
});
